import { baseSplitZodSchema, TreatmentType } from "@redotech/redo-model/split";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createSplit = {
  name: "createSplit" as const,
  input: z.object({
    teamId: zExt.objectId(),
    name: z.string(),
    treatmentType: createEnum(TreatmentType),
  }),
  output: z.object({ split: baseSplitZodSchema }),
};
